import _ from "lodash";
import React, { useEffect, useState } from "react";
import Button from "../../components/buttons";
import { IconButton } from "../../components";
import { Modal } from "react-bootstrap";
import { useFilterContext } from "../../hooks/FilterContext";
import { FormSelect, DateInput, FormInput, FormCheck } from "../../components/forms/";
import { GenericUserSelect } from "../../components/forms/selects";
import { GenericAdviserSelect } from "../../components/forms/selects";
import ThemedModal from "../../components/utilities/ThemedModal";

export const AdministrationRemindersFiltersModalButton = ({
    className,
    variant = "primary",
    ...rest
}) => {
    return (
        <IconButton icon={['fas', 'filter']} variant={variant} {...rest}>
            Filter Reminders
        </IconButton>
    );
    // return (
    //     <div className={className}>
    //         <Button variant={variant} {...rest}>
    //             Filter Reminders
    //         </Button>
    //     </div>
    // );
};

export const AdministrationRemindersFiltersModal = ({
    handleClose,
    onFiltersChanged,
    show,
    ...rest
}) => {
    const { defaultFilters, filter, setFilter } = useFilterContext();
    const [tempFilters, setTempFilters] = useState(filter);

    const onApplyFilters = () => {
        setFilter((original) => {
            return {
                ...original,
                ...tempFilters,
            };
        });
        onClose();
    };

    const onClearFilters = () => {
        setTempFilters((_) => defaultFilters);
    };

    const onFilterValueChanged = (property, value) => {
        setTempFilters((original) => {
            return {
                ...original,
                [property]: value,
            };
        });
    };

    const onClose = () => {
        if (handleClose && typeof handleClose === "function") {
            handleClose();
        }
    };

    useEffect(() => {
        if (!_.isEqual(filter, tempFilters)) {
            setTempFilters((_) => filter);
        }
    }, [filter]);

    return (
        <Modal size="lg" centered backdrop="static" show={show}>
            <ThemedModal.Header>
                <Modal.Title>Admin Reminders Filters</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body {...rest}>
                <AdministrationRemindersFilters
                    filter={tempFilters}
                    setFilter={onFilterValueChanged}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="warning" onClick={onClearFilters}>
                    Clear Filters
                </Button>
                <Button variant="success" onClick={onApplyFilters}>
                    Apply Filters
                </Button>
                <Button variant="light" onClick={onClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

const AdministrationRemindersFilters = ({ filter, setFilter }) => {
    const {
        message,
        createdByIds,
        reminderDateStart,
        reminderDateEnd,
        hideCompleted,
        completedByIds,
        completedDateStart,
        completedDateEnd,
    } = filter;

    return (
        <React.Fragment>
            <div className="row mb-3">
                <div className="col">
                    <FormInput
                        id="message"
                        label="Message"
                        value={message}
                        placeholder="Message"
                        onBlur={(value) => setFilter("message", value)}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <GenericUserSelect
                        label="Created By"
                        isMulti={true}
                        defaultValue={createdByIds}
                        disableAnimations={true}
                        onBlur={(values) =>
                            setFilter(
                                "createdByIds",
                                values.map((el) => el.value)
                            )
                        }
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <DateInput
                        label="Reminder Date From"
                        placeholder="Reminder From"
                        isClearable
                        disableAnimations={true}
                        value={reminderDateStart}
                        onBlur={(value, _) =>
                            setFilter("reminderDateStart", value)
                        }
                    />
                </div>
                <div className="col">
                    <DateInput
                        label="Reminder Date To"
                        placeholder="Reminder To"
                        isClearable
                        disableAnimations={true}
                        value={reminderDateEnd}
                        onBlur={(value, _) =>
                            setFilter("reminderDateEnd", value)
                        }
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <FormCheck
                        label="Hide Completed"
                        isChecked={hideCompleted}
                        onChange={() => setFilter('hideCompleted', !hideCompleted)}
                        disableAnimations
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <GenericUserSelect
                        label="Completed By"
                        isMulti={true}
                        defaultValue={completedByIds}
                        disableAnimations={true}
                        onBlur={(values) =>
                            setFilter(
                                "completedByIds",
                                values.map((el) => el.value)
                            )
                        }
                        isDisabled={hideCompleted}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <DateInput
                        label="Completed Date From"
                        value={completedDateStart}
                        placeholder="Completed From"
                        isClearable
                        disableAnimations={true}
                        onBlur={(value, _) =>
                            setFilter("completedDateStart", value)
                        }
                        disabled={hideCompleted}
                    />
                </div>
                <div className="col">
                    <DateInput
                        label="Completed Date To"
                        placeholder="Completed To"
                        isClearable
                        disableAnimations={true}
                        value={completedDateEnd}
                        onBlur={(value, _) =>
                            setFilter("completedDateEnd", value)
                        }
                        disabled={hideCompleted}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default AdministrationRemindersFilters;
